import Api from "./axios"

const measurementTableService = {
    
        getDatasetMeasurementTables(datasetId) {
            return Api.get(`/measurement-tables/?dataset_id=${datasetId}`)
        }
}

export default measurementTableService;